import type { FC } from 'react';
import { useGetInternalAuditReportById } from 'src/hooks/queries';

type Props = {
  assessmentId: string | undefined;
};

const Breadcrumb: FC<Props> = ({ assessmentId }) => {
  if (!assessmentId) {
    throw new Error('Missing assessmentId param');
  }
  const { data } = useGetInternalAuditReportById(assessmentId);

  return <>{data?.internal_audit_report?.[0]?.Title || ''}</>;
};

export default Breadcrumb;
